import React from "react";

interface BaseIconProps {
  className?: string;
  isActive?: boolean;
}

export default function LockedIcon({ className, isActive }: BaseIconProps) {
  return (
    <svg
      viewBox="0 0 40 40"
      className={className}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20 28.3334C19.116 28.3334 18.2681 27.9822 17.643 27.3571C17.0179 26.732 16.6667 25.8841 16.6667 25.0001C16.6667 23.1501 18.15 21.6667 20 21.6667C20.8841 21.6667 21.7319 22.0179 22.357 22.6431C22.9822 23.2682 23.3334 24.116 23.3334 25.0001C23.3334 25.8841 22.9822 26.732 22.357 27.3571C21.7319 27.9822 20.8841 28.3334 20 28.3334ZM30 33.3334V16.6667H10V33.3334H30ZM30 13.3334C30.8841 13.3334 31.7319 13.6846 32.357 14.3097C32.9822 14.9348 33.3334 15.7827 33.3334 16.6667V33.3334C33.3334 34.2175 32.9822 35.0653 32.357 35.6904C31.7319 36.3156 30.8841 36.6667 30 36.6667H10C9.11597 36.6667 8.26812 36.3156 7.643 35.6904C7.01788 35.0653 6.66669 34.2175 6.66669 33.3334V16.6667C6.66669 14.8167 8.15002 13.3334 10 13.3334H11.6667V10.0001C11.6667 7.78994 12.5447 5.67033 14.1075 4.10752C15.6703 2.54472 17.7899 1.66675 20 1.66675C21.0944 1.66675 22.178 1.8823 23.189 2.30109C24.2001 2.71987 25.1188 3.3337 25.8926 4.10752C26.6664 4.88135 27.2802 5.80001 27.699 6.81105C28.1178 7.8221 28.3334 8.90573 28.3334 10.0001V13.3334H30ZM20 5.00008C18.6739 5.00008 17.4022 5.52687 16.4645 6.46455C15.5268 7.40223 15 8.674 15 10.0001V13.3334H25V10.0001C25 8.674 24.4732 7.40223 23.5356 6.46455C22.5979 5.52687 21.3261 5.00008 20 5.00008Z"
        fill={isActive ? "#663399" : "#000"}
      />
    </svg>
  );
}
